import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export function BasicManagementPermissionScreen() {
  this.view_flag = 1;
  this.edit_flag = 1;
  this.menu_id = "";
  this.id = "";
}

export function initialize() {
  return Object.assign({}, new BasicManagementPermissionScreen());
}

const state = () => ({
  management_permission_view: initialize(),
});

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
